import React, { useState, useEffect } from 'react';
import { withStyles, Button, LinearProgress } from '@material-ui/core';
import classnames from 'classnames';
import DatePicker from '../../../components/DatePicker';
import Checkbox from '@material-ui/core/Checkbox';
import { addMonths, startOfMonth, addDays } from 'date-fns';

// SERVICES
import { getNewRevenueReport } from '../../../services';
import { getInitialReportMonth, monthsOptions } from '../../../helpers/constants/months';
import { Autocomplete } from '../../../components/Autocomplete';

const styles = theme => ({
  datePicker: {
    padding: 10,
  },
});

export const NewRevenueReport = withStyles(styles)(props => {
  const { classes } = props;

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);
  const [error, setError] = useState('');
  const [reportMonth, setReportMonth] = useState(getInitialReportMonth);

  const getNewRevenueReportAsync = useCustomDates => async () => {
    setError('');

    try {
      setIsGeneratingReport(true);
      if (useCustomDates) {
        await getNewRevenueReport({});
      } else {
       
        const invoicePeriod = reportMonth.label;
        await getNewRevenueReport({ invoicePeriod });
      }     
    } catch (error) {
      
      console.log({error})
      setError(error.message);
    } finally {
      setIsGeneratingReport(false);
    }
  };

  const customDateInvalid = true;
  const selectedPeriodInvalid = !reportMonth;

  return (
    // <div className={classes.reportWrapper}>
    <div className={classnames('flex-1', 'col-center-center', 'align-stretch', 'card', 'border-left-green')}>
      <h3 style={{ marginBottom: 36 }}>
        Select an option to download the New Revenue Report.
      </h3>

      <div className={classnames('flex-col')}>
        <div className={classnames('row-between-center')}>
          

          <Button
            variant="contained"
            style={{ backgroundColor:'var(--jmi-blue)', color: 'white', marginLeft: 24 }}
            onClick={getNewRevenueReportAsync(true)}
            disabled={isGeneratingReport}
          >
            Get Un-Invoiced Revenue Report
          </Button>
        </div>

        <div className={classnames('row-between-center')} style={{ marginTop: 48 }}>
          <div style={{ flex: 1, minWidth: 300 }}>
            <Autocomplete
              // disabled={showGrid}
              options={monthsOptions}
              value={reportMonth}
              onChange={setReportMonth}
            />
          </div>

          <Button
            variant="contained"
            style={{ backgroundColor: selectedPeriodInvalid ? '#aaa' : 'var(--jmi-blue)', color: 'white', marginLeft: 24 }}
            onClick={getNewRevenueReportAsync(false)}
            disabled={selectedPeriodInvalid || isGeneratingReport}
          >
            Get Report
          </Button>
        </div>

        <div style={{ width: '100%', marginTop: 24 }}>
          <div
            style={{
              visibility: isGeneratingReport ? 'visible' : 'hidden',
            }}
          >
            <LinearProgress />
          </div>
          <div style={{ maxWidth: 400, color: 'red' }}>{error}</div>
        </div>
      </div>
    </div>
  );
});
